<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <announcements-add
          @handleAddAnnouncement="handleAddAnnouncement"
          @handleEditAnnouncement="handleEditAnnouncement"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import Announcements from "@/services/announcements.service";
import { notify } from "@/helpers/notify";
import TitleBar from "@/components/TitleBar";
import CardComponent from "@/components/CardComponent";
import AnnouncementsAdd from "../components/announcements/announcements-add.vue";

export default {
  name: "Announcement",
  components: { TitleBar, CardComponent, AnnouncementsAdd },
  data() {
    return {
      editMode: false,
    };
  },
  methods: {
    async handleAddAnnouncement(announcement) {
      try {
        const { handleAddAnnouncement } = Announcements;
        const response = await handleAddAnnouncement(announcement);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Anuntul a fost adaugat.");
          this.$router.push({ path: "/Announcements" });
        } else {
          notify.error(this, "Eroare la adaugarea anuntului.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditAnnouncement(announcement) {
      try {
        const { handleEditAnnouncement } = Announcements;
        const response = await handleEditAnnouncement(announcement);
        notify.success(this, "Anuntul a fost modificat.");
        this.$router.push({ path: "/Announcements" });
      } catch (error) {
        notify.error(this, "Eroare la modificarea anuntului.");
      }
    },
  },
  computed: {
    titleStack() {
      const parent = { label: "Anunturi", to: "/Announcements" };
      if (this.editMode) {
        return [parent, "Editare anunt"];
      } else {
        return [parent, "Adaugare anunt"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare anunt";
      } else {
        return "Adaugare anunt";
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    } else {
      this.announcement.date = new Date();
    }
  },
};
</script>
